import Class from './monitoring';
import './monitoring@';

export default Class;